<template>
    <div
        class="
            product-filter-item-title
            d-flex
            align-center
            font-weight-bold
            py-5
        "
    >
        <h4
            class="py-0 my-0"
        >
            {{ name }}
        </h4>
        <v-badge
            class="ms-2"
            color="accent"
            :model-value="badge"
            :content="count"
            inline
        ></v-badge>
    </div>
</template>

<script lang="ts" setup>
    const props = defineProps<{
        count: number;
        name: string;
    }>();

    const badge = computed<boolean>(() => Boolean(props.count));
</script>

<style lang="scss">
.product-filter-item-title {
    height: 2rem;
}
</style>
